export const PHONE_DISPLAY = "06 38 47 43 00";
export const PHONE_TEL = "tel:+33638474300";
export const WHATSAPP_URL =
  "https://wa.me/33638474300?text=Bonjour%20WM%20Clean%2C%20je%20souhaite%20un%20devis%20gratuit.";
export const EMAIL = "cleanwmpro@gmail.com";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1512479373983-bd28a541041b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NxA5O1x8MHxfc2VhcmNofDJ8fHdpbmRvdyUyMGNsZWFuaW5nJTIwc3F1ZWVnZWUlMjBjbGVhbiUyMGdsYXNzJTIwd29ya2VyfGVufDB8fHx8MTc4NjczMDQ2OHww&ixlib=rb-4.1.0&q=85",
  hauteur: "https://images.unsplash.com/photo-1534350752840-1b1b71b4b4fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NxA5O1x8MHxfc2VhcmNofDN8fHdpbmRvdyUyMGNsZWFuaW5nJTIwc3F1ZWVnZWUlMjBjbGVhbiUyMGdsYXNzJTIwd29ya2VyfGVufDB8fHx8MTc4NjczMDQ2OHww&ixlib=rb-4.1.0&q=85",
  facade: "https://images.unsplash.com/photo-1421940943431-d392fcc1079f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NxA5O1x8MHxfc2VhcmNofDF8fHdpbmRvdyUyMGNsZWFuaW5nJTIwc3F1ZWVnZWUlMjBjbGVhbiUyMGdsYXNzJTIwd29ya2VyfGVufDB8fHx8MTc4NjczMDQ2OHww&ixlib=rb-4.1.0&q=85",
  veranda: "https://images.unsplash.com/photo-1762532559987-5d2cf370eaac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBnbGFzcyUyMGhvdXNlJTIwaW50ZXJpb3IlMjBzdW5saWdodCUyMGx1eHVyeSUyMHdpbmRvd3xlbnwwfHx8fDE3ODgzNTc1MzZ8MA&ixlib=rb-4.1.0&q=85",
  storefront: "https://images.unsplash.com/photo-1764327212322-2d5e4d518176?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxjbGVhbiUyMGdsYXNzJTIwd2luZG93JTIwc3VubGlnaHQlMjBtb2Rlcm4lMjBhcGFydG1lbnQlMjBidWlsZGluZyUyMHN0b3JlZnJvbnR8ZW58MHx8fHwxNzg4MzU3NTI2fDA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    icon: "Home",
    title: "Vitres particuliers",
    desc: "Maisons et appartements : fenêtres, baies vitrées, portes-fenêtres, intérieur et extérieur.",
  },
  {
    icon: "Store",
    title: "Vitrines commerciales",
    desc: "Boutiques, restaurants, bureaux : une vitrine éclatante qui attire les clients.",
  },
  {
    icon: "Building2",
    title: "Immeubles & copropriétés",
    desc: "Halls, cages d'escalier, parties communes : contrats pour syndics et gestionnaires.",
  },
  {
    icon: "Sun",
    title: "Vérandas & verrières",
    desc: "Toits vitrés, vérandas, verrières d'atelier : redonnez-leur toute leur lumière.",
  },
  {
    icon: "Repeat",
    title: "Ponctuel ou régulier",
    desc: "Intervention unique ou contrat d'entretien mensuel / trimestriel, à votre rythme.",
  },
];

export const WHY_US = [
  {
    num: "01",
    icon: "Zap",
    title: "Rapidité",
    desc: "Devis gratuit sous 24h et intervention en 48h sur Lille et toute la métropole.",
  },
  {
    num: "02",
    icon: "Leaf",
    title: "Produits écologiques",
    desc: "Eau pure déminéralisée, sans produits chimiques : un éclat durable, zéro trace.",
  },
  {
    num: "03",
    icon: "ShieldCheck",
    title: "Assurance complète",
    desc: "Responsabilité civile professionnelle : vos biens sont couverts à chaque passage.",
  },
  {
    num: "04",
    icon: "BadgeCheck",
    title: "Satisfait ou refait",
    desc: "Si le résultat ne vous convient pas, nous revenons gratuitement sous 72h.",
  },
];

export const CITIES = [
  "Lille",
  "Roubaix",
  "Tourcoing",
  "Villeneuve-d'Ascq",
  "Marcq-en-Barœul",
  "Lambersart",
  "La Madeleine",
  "Bondues",
  "Wasquehal",
];

export const MARQUEE_ITEMS = [
  "Lille",
  "Satisfait ou refait",
  "Roubaix",
  "Eau pure écologique",
  "Tourcoing",
  "Devis sous 24h",
  "Villeneuve-d'Ascq",
  "Assurance RC Pro",
  "Marcq-en-Barœul",
  "Intervention en 48h",
  "Lambersart",
  "La Madeleine",
  "Bondues",
  "Wasquehal",
];

export const PRICING = [
  {
    id: "ponctuel",
    name: "Ponctuel",
    price: "dès 59 €",
    tagline: "L'intervention unique, sans engagement",
    features: [
      "Vitres intérieur + extérieur",
      "Rails et encadrements inclus",
      "Déplacement offert en métropole",
      "Idéal avant un événement ou une vente",
    ],
    highlighted: false,
    cta: "Demander ce devis",
  },
  {
    id: "mensuel",
    name: "Mensuel",
    price: "sur devis",
    tagline: "La formule préférée des commerces",
    features: [
      "Un passage chaque mois",
      "-15 % par rapport au ponctuel",
      "Priorité au planning",
      "Vitrine impeccable toute l'année",
    ],
    highlighted: true,
    cta: "Demander ce devis",
  },
  {
    id: "trimestriel",
    name: "Trimestriel",
    price: "sur devis",
    tagline: "La tranquillité pour les particuliers",
    features: [
      "4 passages par an",
      "Rappel automatique avant chaque visite",
      "Tarif dégressif garanti",
      "Vérandas et baies vitrées incluses",
    ],
    highlighted: false,
    cta: "Demander ce devis",
  },
];

export const TESTIMONIALS = [
  {
    name: "Sophie Lemaire",
    city: "Lille",
    stars: 5,
    text: "Equipe ponctuelle et très soigneuse. Mes baies vitrées n'ont jamais été aussi propres. Je recommande les yeux fermés.",
  },
  {
    name: "Karim Boudiaf",
    city: "Roubaix",
    stars: 5,
    text: "Notre vitrine de boutique est nettoyée chaque mois. Résultat impeccable et tarif très correct. Service client au top.",
  },
  {
    name: "Marie Dubois",
    city: "Marcq-en-Barœul",
    stars: 5,
    text: "Ils ont nettoyé notre véranda en hauteur sans aucun problème. Travail rapide, propre, et produits écologiques en plus.",
  },
  {
    name: "Thomas Vermeersch",
    city: "Tourcoing",
    stars: 4,
    text: "Devis reçu en quelques heures, intervention deux jours après. Professionnels et discrets. Je signerai pour un contrat régulier.",
  },
];

export const PROPERTY_TYPES = [
  "Maison",
  "Appartement",
  "Commerce / Vitrine",
  "Immeuble / Copropriété",
  "Bureaux",
  "Véranda / Verrière",
];

export const SERVICE_TYPES = ["Ponctuel", "Mensuel", "Trimestriel", "Je ne sais pas encore"];
